import type { OrderType } from './types'

export const PORTING_SUB_ORDER_ID = 22
export const TERMINATION_SUB_ORDER_ID = 23

export const INITIAL_PER_PAGE_LIMIT = 100
export const PER_PAGE_LIMIT = 100

export const TERMINATION_ORDER_TYPE = {
  TRANSFER: 0,
  CANCELLATION: 2,
  USER_DECIDES: 3,
} as const

export const DEFAULT_ORDER_TYPE: OrderType = 'porting'
